import { Injectable } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';

@Injectable({
  providedIn: 'root',
})
export class FormlyErrorService {
  getErrorMessage(field: FormlyFieldConfig): string {
    const errors = field.formControl?.errors;

    if (!errors) {
      return '';
    }

    // Get the first error key
    const errorKey = Object.keys(errors)[0];
    const error = errors[errorKey];

    // If there's a custom error message in the field props, use that
    if (field.props?.errorMessages?.[errorKey]) {
      return field.props.errorMessages[errorKey](error);
    }

    // Default error messages
    switch (errorKey) {
      case 'required':
        return 'Dit veld is verplicht';
      case 'min':
        return `Minimale waarde is ${error.min}`;
      case 'max':
        return `Maximale waarde is ${error.max}`;
      case 'minLength':
        return `Minimaal ${error.requiredLength} karakters vereist`;
      case 'maxLength':
        return `Maximaal ${error.requiredLength} karakters toegestaan`;
      case 'email':
        return 'Voer een geldig e-mailadres in';
      case 'invalidIban':
        return 'Voer een geldig IBAN-nummer in';
      case 'invalidPhone':
        return 'Voer een geldig telefoonnummer in';
      case 'number':
        return 'Voer een geldige waarde in';
      case 'pattern':
        return 'Ongeldige waarde';
      default:
        return error;
    }
  }

  static validateOptions(field: FormlyFieldConfig, filteredOptions: Array<any>, currentValue: any): FormlyFieldConfig {
    // Cannot validate against empty options list — options may not have loaded yet
    if (filteredOptions.length === 0) {
      return field;
    }

    let option;
    if (!Array.isArray(currentValue)) {
      option = filteredOptions.find(opt => opt.value?.id === currentValue?.id);
    } else {
      // TODO improve array checking logic
      option = filteredOptions.find(opt => opt.value?.id === currentValue[0]?.id);
    }
    if (option == null) {
      const displayValue = currentValue?.selectedInput || currentValue?.name || currentValue;
      // Set error on the form control instead of warning message
      field.formControl.setErrors({
        invalidOption: `Huidige waarde '${displayValue}' is niet meer beschikbaar als optie.`,
      });
    } else {
      // Clear the specific error if option is valid
      const currentErrors = field.formControl.errors;
      if (currentErrors) {
        delete currentErrors.invalidOption;
        // If no errors left, set to null
        field.formControl.setErrors(Object.keys(currentErrors).length ? currentErrors : null);
      }
    }
    return field;
  }
}
